export const B3_AUTH_COOKIE_NAME = "b3-auth";
export const B3OS_ORG_COOKIE_NAME = "b3os-selected-orgId";
export const B3OS_LAST_ORG_COOKIE_NAME = "b3os-last-orgId";
export const B3OS_GATE_COOKIE_NAME = "b3os-gate";
export const B3OS_MASQUERADE_COOKIE_NAME = "b3os-masquerade";
